"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabMenu = exports.TabList = exports.TAB_OFFSET = exports.RESERVED_OFFSET = exports.RESERVED_WIDTH = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const Tabs_1 = require("../Tabs");
const Dropdown_1 = require("./Dropdown");
/** Width of the dropdown element */
exports.RESERVED_WIDTH = 120;
/** An offset used in width calculations that increases the
reserved space for the dropdown without changing the size of the dropdown. */
exports.RESERVED_OFFSET = 16;
/** An offset used in width calculations that ensures that tabs are not
cut-off when reorganizing the tab list. */
exports.TAB_OFFSET = 16;
exports.TabList = (0, styled_1.default)(Tabs_1.TabList) `
  flex-wrap: nowrap;
  overflow: hidden;
  min-height: 50px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;
exports.TabMenu = (0, styled_1.default)(Dropdown_1.Dropdown) `
  width: ${exports.RESERVED_WIDTH}px;
  min-width: ${exports.RESERVED_WIDTH}px;
  min-height: 25px;
  height: 100%;
  margin-left: auto;
`;
//# sourceMappingURL=DropdownTabs.styles.js.map